module.exports = __webpack_public_path__ + "assets/cd7765f55590a397fd37db56ca879bdb.mp3";